module.exports = __webpack_public_path__ + "img/collection-weddingRingsSlim.e334747.jpg";